import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { MaterialModule } from "src/app/material.module";
import { SharedModule } from "src/app/shared.module";
import { UiScrollModule } from "ngx-ui-scroll";
import { GadgetSettingsComponent } from "./gadget-settings.component";
import { PhotoSelectorModule } from "../photo-selector/photo-selector.component.module";

@NgModule({
    imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    MaterialModule,
    SharedModule,
    UiScrollModule,
    PhotoSelectorModule,
],
    declarations: [GadgetSettingsComponent],
    exports: [GadgetSettingsComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
    
})
export class GadgetSettingsModule {}